<script >
  export default {
    name: 'brochure',
    mounted() {
      window.location.href = "/brobook.html"
    }
  }

</script>

<template>
<div>
  <div class="uk-container uk-padding-large">
    <h1 class="uk-text-center">NCU Academic Brochure</h1> <br>

    <div class="pdf uk-padding">
<!--      <object data="https://www.ncu.edu.jm/brobook.pdf" type="application/pdf" width="100%" height="800px">
        <p>Your web browser doesn't have a PDF plugin.
          Instead you can <a href="https://www.ncu.edu.jm/brobook.pdf">click here to
            download the PDF file.</a></p>
      </object>-->
<!--      <iframe src="https://www.ncu.edu.jm/brobook.pdf" title='SOME_TITLE' width="100%" height="100%" />-->
<!--      <embed class=""
          src="https://www.ncu.edu.jm/brobook.pdf"
          frameBorder="0"
          scrolling="auto"
          height="800px"
          width="100%"
      >-->
    </div>

  </div>

</div>
</template>

<style scoped>
.pdf {
  width: 100%;
  aspect-ratio: 4 / 3;
}
.pdf,
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
@media only screen and (max-width: 600px)  {
  .pdf{


  }
}
</style>